module.exports = __webpack_public_path__ + "257b40bcd465eaf45e04b08de8f63f65.pdf";